<template>
  <v-container>
    <v-row v-if="!showDeleteButton">
      <v-col cols="8" sm="4" md="3">
        <SimpleDatePicker
          :label="'Date'"
          :value="date"
          :isRequired="true"
          @selected-date-change="dateChangeHandler"
        ></SimpleDatePicker>
      </v-col>
      <v-col cols="4" sm="2" md="3">
        <FormattedNumberField
          label="Hours"
          :value="hoursValue"
          :required="true"
          @valueChange="(newValue) => this.hoursValue = newValue"
        ></FormattedNumberField>
      </v-col>
      <v-col cols="6" sm="3">
        <FormattedNumberField
          label="O/T Pay Rate"
          :value="otPayRateValue"
          :required="true"
          prepend-inner-icon="attach_money"
          @valueChange="(newValue) => this.otPayRateValue = newValue"
        ></FormattedNumberField>
      </v-col>
      <v-col cols="6" sm="3">
        <FormattedNumberField
          label="O/T Bill Rate"
          :value="otBillRateValue"
          :required="true"
          prepend-inner-icon="attach_money"
          @valueChange="(newValue) => this.otBillRateValue = newValue"
        ></FormattedNumberField>
      </v-col>
    </v-row>
    <v-row v-if="showDeleteButton">
      <v-col cols="12" sm="6" md="3">
        <SimpleDatePicker
          :label="'Date'"
          :value="date"
          :isRequired="true"
          @selected-date-change="dateChangeHandler"
        ></SimpleDatePicker>
      </v-col>
      <v-col cols="12" sm="6" md="2">
        <FormattedNumberField
          label="Hours"
          :value="hoursValue"
          :required="true"
          @valueChange="(newValue) => this.hoursValue = newValue"
        ></FormattedNumberField>
      </v-col>
      <v-col cols="12" sm="5" md="3">
        <FormattedNumberField
          label="O/T Pay Rate"
          :value="otPayRateValue"
          :required="true"
          prepend-inner-icon="attach_money"
          @valueChange="(newValue) => this.otPayRateValue = newValue"
        ></FormattedNumberField>
      </v-col>
      <v-col cols="12" sm="5" md="3">
        <FormattedNumberField
          label="O/T Bill Rate"
          :value="otBillRateValue"
          :required="true"
          prepend-inner-icon="attach_money"
          @valueChange="(newValue) => this.otBillRateValue = newValue"
        ></FormattedNumberField>
      </v-col>
      <v-col cols="12" sm="2" md="1">
        <v-btn
          outlined color="error"
          @click="$emit('removeTempOvertimeEntry', id)">
          <v-icon dark>delete</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { SimpleDatePicker } from '@/components/shared/datePickers'
import { required } from '@/lib/formValidations'
import { FormattedNumberField } from '@/components/shared/textFields'

export default {
  components: {
    SimpleDatePicker,
    FormattedNumberField
  },
  props: [
    'hourlyRate',
    'id',
    'date',
    'otPayRate',
    'otBillRate',
    'hours',
    'showDeleteButton'
  ],
  computed: {
    otPayRateValue: {
      get () {
        return this.otPayRate
      },
      set (newOTPayRateValue) {
        this.$emit('otPayRateChangeHandler', { id: this.id, otPayRate: newOTPayRateValue })
      }
    },
    otBillRateValue: {
      get () {
        return this.otBillRate
      },
      set (newOTBillRateValue) {
        this.$emit('otBillRateChangeHandler', { id: this.id, otBillRate: newOTBillRateValue })
      }
    },
    hoursValue: {
      get () {
        return this.hours
      },
      set (newHoursValue) {
        this.$emit('hoursChangeHandler', { id: this.id, hours: newHoursValue })
      }
    }
  },
  methods: {
    dateChangeHandler (newDateValue) {
      this.$emit('dateChangeHandler', { id: this.id, date: newDateValue })
    },
    isLessThanPayRate () {
      return this.otPayRateValue < this.hourlyRate ? 'O/T Pay Rate must be greater than $' + this.hourlyRate : true
    },
    required
  }
}
</script>
